// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import formatDate from "../utils/FDate";
import MetaInfo from 'vue-meta-info';
import BaiduMap from 'vue-baidu-map'

// import VueSource from 'vue-source'

import axios from 'axios'
import url from '../utils/url'
// Vue.use(VueSource)
import 'element-ui/lib/theme-chalk/index.css';
import { Carousel, CarouselItem, Icon, Dialog, Message, Image } from 'element-ui';

var Event = new Vue();

Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Icon)
Vue.use(Dialog)
Vue.use(MetaInfo)
Vue.use(Image)

Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'YOUR_APP_KEY'
})

Vue.prototype.$url = url
Vue.prototype.$axios = axios
Vue.prototype.$message = Message;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$e = Event;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js